import { ExternalToken } from '../mainApi';
import { ApiClientService } from './ApiClientService';

export const getExternalKeys = async (): Promise<ExternalToken[]> => {
  return ApiClientService.getJson<ExternalToken[]>(
    `${ApiClientService.getApiBaseUrl()}/externalTokens`
  );
};

export const deleteExternalKey = async (keyId: string): Promise<void> => {
  await ApiClientService.deleteJson<void>(`${ApiClientService.getApiBaseUrl()}/externalTokens/${keyId}`);
};
